import { testimonials } from '../../../mocks/testimonials';

const platformColors: Record<string, string> = {
  Google: 'text-[#4285F4]',
  Yelp: 'text-[#D32323]',
};

const platformIcons: Record<string, string> = {
  Google: 'ri-google-fill',
  Yelp: 'ri-yelp-fill',
};

export default function Testimonials() {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-12 gap-4">
          <div>
            <span className="inline-block bg-parkside-amber/12 text-parkside-amber text-xs font-bold uppercase tracking-widest px-3.5 py-1.5 rounded-full mb-3">
              Client Reviews
            </span>
            <h2 className="font-display text-4xl md:text-5xl text-parkside-dark tracking-display leading-tight">
              What Our Clients Say
            </h2>
          </div>
          <div className="flex items-center gap-3 flex-shrink-0">
            <div className="flex items-center gap-1">
              {[1,2,3,4,5].map((s) => (
                <span key={s} className="w-5 h-5 inline-flex items-center justify-center">
                  <i className="ri-star-fill text-parkside-amber text-xl" />
                </span>
              ))}
            </div>
            <div>
              <p className="text-parkside-dark font-bold text-sm">5.0 / 5.0</p>
              <p className="text-parkside-stone text-xs">Average Rating</p>
            </div>
          </div>
        </div>

        {/* Review cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 mb-10">
          {testimonials.map((t) => (
            <article
              key={t.id}
              className="bg-parkside-warm rounded-2xl p-7 border border-stone-100 relative overflow-hidden flex flex-col"
            >
              {/* Large decorative quote */}
              <span className="absolute top-3 right-5 font-display text-[96px] text-parkside-cream leading-none select-none pointer-events-none">
                &ldquo;
              </span>

              {/* Stars */}
              <div className="flex gap-0.5 mb-4">
                {[1,2,3,4,5].map((s) => (
                  <span key={s} className="w-4 h-4 inline-flex items-center justify-center">
                    <i className="ri-star-fill text-parkside-amber text-sm" />
                  </span>
                ))}
              </div>

              {/* Review text */}
              <p className="text-parkside-dark text-sm leading-relaxed mb-5 relative z-10 flex-1">
                &ldquo;{t.text}&rdquo;
              </p>

              {/* Author + platform */}
              <div className="flex items-center justify-between pt-4 border-t border-stone-200 mt-auto">
                <div className="flex items-center gap-3">
                  <div className="w-9 h-9 flex items-center justify-center bg-parkside-green/15 rounded-full flex-shrink-0">
                    <span className="text-parkside-green font-bold text-sm">{t.name.charAt(0)}</span>
                  </div>
                  <div>
                    <p className="text-parkside-dark font-bold text-sm">{t.name}</p>
                    <p className="text-parkside-stone text-xs">{t.location}</p>
                  </div>
                </div>
                <div className={`flex items-center gap-1 ${platformColors[t.platform]}`}>
                  <span className="w-5 h-5 inline-flex items-center justify-center">
                    <i className={`${platformIcons[t.platform]} text-base`} />
                  </span>
                  <span className="text-xs font-bold">{t.platform}</span>
                </div>
              </div>
            </article>
          ))}
        </div>

        {/* Bottom trust bar */}
        <div className="bg-parkside-cream rounded-2xl px-8 py-6 flex flex-col md:flex-row items-center justify-between gap-4 border border-stone-100">
          <div className="flex items-center gap-5">
            <div className="flex items-center gap-2">
              <span className="w-6 h-6 inline-flex items-center justify-center">
                <i className="ri-google-fill text-[#4285F4] text-2xl" />
              </span>
              <div>
                <div className="flex gap-0.5">
                  {[1,2,3,4,5].map((s) => (
                    <span key={s} className="w-3 h-3 inline-flex items-center justify-center">
                      <i className="ri-star-fill text-parkside-amber text-xs" />
                    </span>
                  ))}
                </div>
                <p className="text-parkside-stone text-xs">Google Reviews</p>
              </div>
            </div>
            <div className="w-px h-8 bg-stone-200" />
            <div className="flex items-center gap-2">
              <span className="w-6 h-6 inline-flex items-center justify-center">
                <i className="ri-yelp-fill text-[#D32323] text-2xl" />
              </span>
              <div>
                <div className="flex gap-0.5">
                  {[1,2,3,4,5].map((s) => (
                    <span key={s} className="w-3 h-3 inline-flex items-center justify-center">
                      <i className="ri-star-fill text-parkside-amber text-xs" />
                    </span>
                  ))}
                </div>
                <p className="text-parkside-stone text-xs">Yelp Reviews</p>
              </div>
            </div>
          </div>
          <p className="text-parkside-muted text-sm text-center md:text-left max-w-md">
            <strong className="text-parkside-dark">5-star rated across all platforms.</strong> Tampa Bay&apos;s most trusted paver installation company.
          </p>
          <a
            href="tel:813-404-6313"
            className="flex items-center gap-2 bg-parkside-green text-white font-bold px-6 py-3 rounded-xl hover:bg-parkside-greenDark transition-colors whitespace-nowrap cursor-pointer text-sm flex-shrink-0"
          >
            <span className="w-4 h-4 inline-flex items-center justify-center">
              <i className="ri-phone-fill" />
            </span>
            (813) 404-6313
          </a>
        </div>
      </div>
    </section>
  );
}
